/**
 * Copyright 2017-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {CHANGE_EDITING_STATE} from '../actions/editing';

const defaultState = {
    action: null,
    geomType: null,
    feature: null,
    changed: false
};

export default function editing(state = defaultState, action) {
    switch (action.type) {
    case CHANGE_EDITING_STATE: {
        const changed = action.data.feature !== null && action.data.changed === true;
        return {...state, ...action.data, changed: changed};
    }
    default:
        return state;
    }
}
